export default "__VITE_PUBLIC_ASSET__37c1b178__"